export const API_URL_ALL = `https://restcountries.com/v3.1/all`;
export const API_URL_CODE = `https://restcountries.com/v3.1/alpha`;
export const API_URL_NAME = `https://restcountries.com/v3.1/name/{name}?fullText=true`;

